import { ACTION_TYPES } from '~/core/constants'

const { APP } = ACTION_TYPES

const initialState = {
  appType: null,
  authenticated: false,
  clientId: '',
  clientUpdateChannel: '',
  initialized: false,
  isElectron: false,
  locale: 'en',
  userInfo: {
    hasMeetings: true
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP.SET_INIT_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    case APP.SET_LOCALE: {
      return {
        ...state,
        locale: action.payload
      }
    }
    case APP.SET_USER_INFO: {
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.payload
        }
      }
    }
    default:
      return state
  }
}

export default reducer
